export default {
  get() {
    let BASE_URL = process.env.BASE_URL;
    let imgPrefixName = window.config.imgPrefixName;
    return {
      logo_large: BASE_URL + "img/" + imgPrefixName + "/logo_large.png",
      logo_small: BASE_URL + "img/" + imgPrefixName + "/logo_small.png",
      landing1: BASE_URL + "img/" + imgPrefixName + "/landing1.png",
      attached: BASE_URL + "img/" + imgPrefixName + "/attached.png",
      processing: BASE_URL + "img/" + imgPrefixName + "/processing.png",
      agree: BASE_URL + "img/" + imgPrefixName + "/agree.png",
      return: BASE_URL + "img/" + imgPrefixName + "/return.png",
      assign: BASE_URL + "img/" + imgPrefixName + "/assign.png",
      distribution: BASE_URL + "img/" + imgPrefixName + "/distribution.png",
      stepIcon: BASE_URL + "img/" + imgPrefixName + "/stepIcon.png",
    };
  },
};
